import React, { useEffect, useState } from "react";
import Loader from "@components/Loaders/Loader";
import { useNavigate, useSearchParams } from "react-router-dom";
import routes from "@routes/routes";

const ForgotPasswordLoader: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (token && token?.length > 0) {
      navigate(routes.default, {
        state: { showUpdatePasswordForm: true, token },
        replace: true,
      });
    } else {
      setError("Something went wrong. Please try again");
    }
  }, [searchParams, navigate]);
  return (
    <div className="w-full h-screen flex items-center justify-center">
      {error.length === 0 ? (
        <Loader />
      ) : (
        <div className="bg-white shadow-lg rounded-xl w-max-lg h-max-lg flex flex-col items-center justify-center p-10">
          <h2>{error}</h2>
          <button
            className="text-white w-full rounded-md bg-primary p-4 mt-10 my-5 ease-in duration-150 hover:scale-95"
            onClick={() => navigate(routes.default)}
            aria-label="Error message"
          >
            Soemthing went wrong. Please try again.
          </button>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordLoader;
